import { get, forEach } from 'lodash'
import Vue from 'vue'

export default () => ({
    state: {
        locks: {},
        myLocks: [],
        onlineUsers: {},
    },
    getters: {
        getLock: state => entity => get(state.locks, entity),
        getAllLocks: state => state.locks,
        getMyLocks: state => state.myLocks,
        getOnlineUsers: state => state.onlineUsers,
    },
    mutations: {
        setPresence: (state, data) => {
            const user = get(data, 'user')
            if (user) {
                Vue.set(state.onlineUsers, user, Date.now())
            }
        },
        setLock: (state, data) => {
            const entity = get(data, 'entity')
            const user = get(data, 'user')
            const ttl = get(data, 'ttl')
            if (user) {
                Vue.set(state.onlineUsers, user, Date.now())
            }
            if (entity && ttl > 0) {
                const existing = state.locks[entity]
                const startTime = existing && existing.startTime ? existing.startTime : Date.now()
                const lastPing = Date.now()
                Vue.set(state.locks, entity, { user, ttl, startTime, lastPing })
            } else if (entity) {
                Vue.delete(state.locks, entity)
                if (state.myLocks.includes(entity)) {
                    state.myLocks = state.myLocks.filter(e => e !== entity)
                }
            }
        },
        lockTTLTick: state => {
            const now = Date.now()
            forEach(state.locks, (v, k) => {
                if (v.ttl > 0) {
                    v.ttl -= 1
                }
                if (v.ttl <= 0) {
                    Vue.delete(state.locks, k)
                }
            })
            forEach(state.onlineUsers, (lastPing, user) => {
                if (now - lastPing > 90000) {
                    Vue.delete(state.onlineUsers, user)
                }
            })
        },
        addMyLock: (state, entity) => {
            if (!state.myLocks.includes(entity)) {
                state.myLocks.push(entity)
            }
        },
        removeMyLock: (state, entity) => {
            state.myLocks = state.myLocks.filter(e => e !== entity)
        },
    },
})

